<script lang="ts">
	import FileUploader from "@components/form/FileUploader.svelte";
	import Labelled from "@components/form/Labelled.svelte";
	import type { ComponentProps, Snippet } from "svelte";
	import type { ClassValue, HTMLLabelAttributes } from "svelte/elements";

	const {
		wrapperClass,
		label,
		children,
		...rest
	}: ComponentProps<typeof FileUploader> & {
		wrapperClass?: ClassValue;
		children: Snippet;
		label?: HTMLLabelAttributes;
	} = $props();
</script>

<Labelled {wrapperClass} required={rest.required} {label}>
	{@render children()}
	{#snippet content()}
		<FileUploader {...rest} />
	{/snippet}
</Labelled>
